const API_HOST = process.env.REACT_APP_API_HOST
const ENVIRONMENT = process.env.NODE_ENV

export default {
  API_HOST,
  ENVIRONMENT
}
